import React from 'react';
import { UseApps, UseLinks } from '../../types';
import { SUPPORT_EMAIL } from '../../constants';
import { trackEvent } from '../../helpers/amplitude';
import { Links } from '../Links';
import { Form } from '../Form';
import { NoData } from './NoData';

interface ContentProps {
  apps: UseApps;
  links: UseLinks;
}

export const Content: React.FC<ContentProps> = ({ apps, links }) => {
  if (apps.options.length === 0) {
    return (
      <NoData title="No apps available">
        <p>There are no apps that you can manage at the moment</p>
        <p>
          Please contact <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> to help you out
        </p>
      </NoData>
    );
  }

  return (
    <div className="flex-one flex-box-row flex-justify-center">
      <Form
        editFields={links.editFields}
        appsOptions={apps.options}
        onAppChange={apps.fetchDetails}
        onTrackEvent={trackEvent}
        onCreate={links.create}
        onUpdate={links.update}
        onCancel={links.skipEdit}
      />
      {!links.editFields && <Links links={links} onTrackEvent={trackEvent} />}
      {links.isLoading && <div className="loader-overlay loader-overlay-show pale" />}
    </div>
  );
};
